var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VehicleInspectionForm',{ref:"VehicleInspectionForm",attrs:{"UniqueId":_vm.UniqueId,"FormType":"Create","InspectionId":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }